import { ToastrService } from 'ngx-toastr';
import { isNullOrUndefined } from 'util';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthenticationService } from '../_services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-root, [app-root]',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit {
  formulario: FormGroup;
  formSenha: FormGroup;
  returnUrl: string;
  isLoggedIn = false;
  emailValid = false;

  constructor(
    private _formBuilder: FormBuilder,
    private _authService: AuthenticationService,
    private _router: Router,
    private _tostr: ToastrService,
    private _route: ActivatedRoute) {

    this.formSenha = _formBuilder.group({
      senha: [null, [Validators.required, Validators.email]]
    });

    this.formulario = _formBuilder.group({
      email: [null, [Validators.required, Validators.email]],
      senha: [null, [Validators.required]],
    });

  }

  ngOnInit() {

    if (this._authService.isLoggedIn) {
      this._authService.redirect();
    }

    this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';
    this._authService.isLoggedIn.subscribe(
      (data) => {
        this.isLoggedIn = data;
      }
    );
  }

  checkEmail(form) {
    this.emailValid = form.valid;
  }

  // onSubmit() {

  //   const controls = this.formulario.controls;

  //   const email = controls.email.value;
  //   const senha = controls.senha.value;

  //   if (this.formulario.valid) {
  //     console.log(email, senha);

  //     this._authService.login(email, senha)
  //       .then(
  //         data => {
  //           this._router.navigate([this.returnUrl]);
  //         })
  //       .catch(error => {
  //         // this.showAlert('alertSignin');
  //         // this._alertService.error(error);
  //         // this.loading = false;
  //       });

  //   } else {

  //   }
  // }

  onSubmit() {
    const controls = this.formulario.controls;
    const email = controls.email.value;
    const senha = controls.senha.value;

    if (this.formulario.valid) {
      this._authService.login(email, senha)
        .then(data => {
          if (!isNullOrUndefined(data) && data.emailVerified) {
            // console.log(data);
            this._authService.redirect();
          } else {
            this._authService.sendActivationEmail()
              .then(resp => {
                this._tostr.warning('Email de confirmação enviado!');
              })
              .catch(error => {
                this._tostr.error('Falha ao enviar confirmação enviado: ' + error);
              });
            this._authService.logout();
          }
        })
        .catch(error => {
          switch (error.code) {
            case 'auth/invalid-email':
              this._tostr.warning('Usuário ou senha inválidos!');
              break;
            case 'auth/user-disabled':
              this._tostr.warning('Acesso desabilitado!');
              break;
            case 'auth/user-not-found':
              this._tostr.warning('Usuário ou senha inválidos!');
              break;
            case 'auth/wrong-password':
              this._tostr.warning('Usuário ou senha inválidos!');
              break;
          }
        });
    } else {
      this._tostr.warning('Verifique as informações de acesso!');
    }
  }

  restorePassword(email: string) {
    this._authService.restorePassword(email)
      .then(data => {
        this._tostr.success('Mensagem enviada! Verifique sua caixa de email.');
      });
  }
}
